import React, { useEffect, useRef } from 'react'

import type { StatefulScrollViewProps } from './types'
import { useScrollTracking } from './useScrollTracking'

export const StatefulScrollView = ({
    savedPosition,
    scrollToBottomKey,
    onScroll,
    onEnd,
    children,
}: StatefulScrollViewProps) => {
    const viewRef = useRef<HTMLDivElement>(null)
    const trackScroll = useScrollTracking(onScroll, onEnd)

    useEffect(() => {
        const view = viewRef.current
        if (view && savedPosition && view.scrollTop !== savedPosition.scrollTop) {
            view.scrollTop = savedPosition.scrollTop
        }
    }, [savedPosition])

    useEffect(() => {
        const view = viewRef.current
        if (view && scrollToBottomKey !== undefined) {
            view.scrollTop = view.scrollHeight
        }
    }, [scrollToBottomKey])

    return (
        <div className='relative h-full w-full overflow-hidden'>
            <div
                ref={viewRef}
                className='absolute inset-0 overflow-auto'
                onScroll={event => trackScroll(event.currentTarget)}
            >
                {children}
            </div>
        </div>
    )
}

StatefulScrollView.displayName = 'StatefulScrollView'
